export default {
  en: {
    roleplayTitle: 'Roleplay',
    idiomTitle: 'Idioms',
  },
  ru: {
    roleplayTitle: 'Ролевые игры',
    idiomTitle: 'Идиомы',
  },
  de: {
    roleplayTitle: 'Rollenspiele',
    idiomTitle: 'Idiome',
  },
  pt: {
    roleplayTitle: 'Jogos de papéis',
    idiomTitle: 'Expressões',
  },
  fr: {
    roleplayTitle: 'Jeux de rôle',
    idiomTitle: 'Expressions',
  },
  es: {
    roleplayTitle: 'Juegos de rol',
    idiomTitle: 'Modismos',
  },
};
